export const transformPath = (input: string): string => {
    return `/${input.replace('root_', '').split('_').join('/')}`;
};

export function valueExistInCustomValuePaths(valueRaw: string, customValuePaths: string[]): boolean {
    const path = transformPath(valueRaw);
    return customValuePaths.includes(path);
}

export const resolveObjectPath = (obj: Record<string, unknown>, path: string): string | null => {
    // Remove the #/definitions prefix if present
    const cleanPath = path.replace('#/definitions/', '');

    // Split the path into segments
    const segments = cleanPath.split('/');

    // Start from the root object
    let current = obj;

    // Traverse through each segment
    for (const segment of segments) {
        if (segment === 'type') {
            break;
        }
        if (typeof current === 'object' && segment in current) {
            // @ts-expect-error
            current = current[segment];
        } else {
            return null; // Path doesn't exist
        }
    }
    if (current['x-secret'] === true) {
        return 'x-secret';
    }

    return null;
};
